import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from '@sm/wds-react';
import { LanguageMenuLI } from './LanguageMenu';
import { AuthedFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import CopyRight from './CopyRight';
import BillingAddress from './BillingAddress';

const AuthedFooter = ({
  domain,
  lang,
  country,
  showBillingAddress,
  isEUDC
}) => {
  return (
    <div className="sm-footer">
      <Grid>
        <Row>
          <Col>
            <LanguageMenuLI lang={lang} />
          </Col>
        </Row>
        <Row>
          <Col md={7} className="wds-flex wds-flex--y-center">
            <div className="wds-flex__item">
              <AuthedFooterLinks domain={domain} lang={lang} />
              {showBillingAddress && <BillingAddress country={country} />}
              <CopyRight />
            </div>
          </Col>
          <Col md={5} className="wds-flex  wds-flex--y-center  wds-flex--x-end">
            <TrusteSeals lang={lang} country={country} isEUDC={isEUDC} />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

AuthedFooter.propTypes = {
  domain: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  lang: PropTypes.string.isRequired,
  showBillingAddress: PropTypes.bool,
  isEUDC: PropTypes.bool
};

AuthedFooter.defaultProps = {
  showBillingAddress: false,
  isEUDC: false
};

export default AuthedFooter;
